import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { resetDividendsIdices } from "../dividendsUXSlice";
import { PageIndex } from "../../../models";
import { setDividendsIndexThunk } from "../thunks/loadDividends";

export const useDividendsIndex = () => {
  const pageIndex = useSelector<StoreType, PageIndex>((s) => s.ux.reports.dividends.index);

  const dispatch = useDispatch();
  const dispatchSetIndex = React.useCallback(
    (index: PageIndex) => dispatch(setDividendsIndexThunk(index)),
    [dispatch]
  );
  const dispatchResetIndex = React.useCallback(
    () => dispatch(resetDividendsIdices()),
    [dispatch]
  );

  return [pageIndex, dispatchSetIndex, dispatchResetIndex] as [
    typeof pageIndex,
    typeof dispatchSetIndex,
    typeof dispatchResetIndex
  ];
};
